import customerSettings from './marketing-impact-customer-settings'

export default {
  getSideEffects (marketing) {
    const sideEffects = [
      ...customerSettings.getSideEffects(marketing)
    ]

    return sideEffects
  },
  applySideEffects (marketing) {
    return customerSettings.applySideEffects(marketing)
  }
}
